module.exports = __webpack_public_path__ + "img/total_premium_filled.8d90e16.svg";